__turbopack_context__.v({
  "diyOptionBlock": "JourneyDetails-module__8FHYAa__diyOptionBlock",
});
